module.exports = __webpack_public_path__ + "static/media/checkboxInstall2.a6566003.svg";